import React from 'react';
import Input from '../../../forms/Input';
import TrackerInputShell from './TrackerInputShell';

interface NumberInput {
  name: string;
  value?: number;
  callback(value: number): void;
}

const NumberInput: React.FC<NumberInput> = ({ name, value, callback }) => (
  <TrackerInputShell trackerName={name}>
    <Input
      placeholder="enter a number"
      wrapperClassName="w-100"
      type="number"
      pattern="[0-9]"
      defaultValue={value}
      onChange={({ target }) => callback(Number(target.value))}
      data-testid="number-input"
    />
  </TrackerInputShell>
);

export default NumberInput;
